<section *ngIf="display$ | async" class="is-flex is-space-between is-align-center">

  <ng-container>
    <div class="air-quality is-flex is-space-between is-align-center is-fullwidth">

      <div class="is-flex is-column gap-4">
        <app-text class="text-14 is-family-semiBold text-quality">{{ 'common-app.__INDOOR_AIR_QUALITY' | AsyncLang | async }}</app-text>
      </div>

      <ng-container *ngIf="indoorAirQuality$ | async as indoorAirQuality; else unreachable">
        <div  class="is-flex is-align-center is-align-self-end gap-12" [style.color]="indoorAirQuality.color">
          <app-text class="aqi-label is-family-semiBold text-12"
            [style.backgroundColor]="indoorAirQuality.backgroundColor">
            {{ indoorAirQuality.label | AsyncLang | async }}
          </app-text>
        </div>
      </ng-container>
    </div>

    <ng-template #unreachable>
      <div class="is-flex is-align-center is-align-self-end gap-12">
        <app-text class="aqi-label is-family-semiBold text-grey-70">--</app-text>
      </div>
    </ng-template>

  </ng-container>

</section>